const initialState = {
  orderHistoryDetails: '',
  orderHistoryCategories: '',
  orderHistoryError: '',
  responseHeaders: '',
  activeSubscriptions: '',
  activeSubscriptionsError: '',
  mySubscriptions: [],
  mySubscriptionsError: '',
  unsubscribeProductPlanResponse: ''
};

const OrderHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ORDER_HISTORY_DETAILS':
      return {
        ...state,
        orderHistoryDetails: action.payload,
        orderHistoryError: '',
        responseHeaders: action.headers
      };
    case 'ORDER_HISTORY_CATEGORIES':
      return {
        ...state,
        orderHistoryCategories: action.payload
      };
    case 'ORDER_HISTORY_ERROR':
      return {
        ...state,
        orderHistoryError: action.payload
      };
    case 'ACTIVE_SUBSCRIPTIONS':
      return {
        ...state,
        activeSubscriptions: action.payload,
        responseHeaders: action.headers,
        orderIdSubscriptions: action.subscriptionpayload
      };
    case 'ACTIVE_SUBSCRIPTIONS_ERROR':
      return {
        ...state,
        activeSubscriptionsError: action.payload
      };
    case 'MY_SUBSCRIPTIONS':
      return {
        ...state,
        mySubscriptions: action.payload
      };
    case 'MY_SUBSCRIPTIONS_ERROR':
      return {
        ...state,
        mySubscriptionsError: action.payload
      };
    case 'UNSUBSCRIBE_PRODUCT_PLAN_RESPONSE':
    case 'RESET_UNSUBSCRIBE_PRODUCT_PLAN_RESPONSE':
      return {
        ...state,
        unsubscribeProductPlanResponse: action.payload
      };
    default:
      return state;
  }
};

export default OrderHistoryReducer;
